<template>
  <tr class="demo-row">
    <td>
      <router-link :to="{ path: '/membership/members/' + account.uuid }">
        {{ account.dropdownLabel }}
      </router-link>
    </td>
    <td>
      <div class="text-center">
        {{ account.registeredDate | short_date_format }}
      </div>
    </td>
    <td>
      <span class="badge" :class="membershipStatus.label">
        {{ membershipStatus.text }}
      </span>
    </td>
    <td>
      <div class="text-center">{{ account.AccountType.name }}</div>
    </td>
    <td>
      <div class="text-center">
        <span class="fa" :class="account.CreditCards.length ? 'fa-check text-success' : 'fa-times text-danger'"></span>
      </div>
    </td>
    <td>
      <div class="text-center">{{ account.homePhone }}</div>
    </td>
    <td>
      <div class="text-center" :class="{ 'text-danger': account.credits < 0 }">
        {{ account.credits | to_dollar_amount_neg }}
      </div>
    </td>
    <td>
      <div class="text-center">
        <router-link v-if="account.Reservations[0]" :to="{ path: '/fleet/reservations/' + account.Reservations[0].uuid }">
           # {{ account.Reservations[0].reservationId }}
        </router-link>
        <em v-else>n/a</em>
      </div>
    </td>
    <td>
      <span class="badge badge-margin" :class="{
        'badge-danger': !account.cardId,
        'badge-success': account.cardId
      }">
        <span class="fa fa-id-card"></span>
        {{ !account.cardId ? 'n/a' : account.Smartcard.cardNumber }}
      </span>
    </td>
    <td>
      <dropdown-input label="Actions"
        :is-small="true"
        label-icon="fa-user"
        :actions="userActions(account, loggedInUser)"
        :dropright="true"
        @action="executeAction($event, account)">
      </dropdown-input>
    </td>
  </tr>
</template>

<script>
import DropdownInput from '@/components/inputs/DropdownInput'
import { mapGetters, mapActions } from 'vuex'
import {
  ADD_ACCOUNT_NOTE,
  ADD_CREDITS,
  ADD_SMARTCARD,
  BLACKLIST_MEMBER,
  UN_BLACKLIST_MEMBER,
  CHANGE_PASS_USER,
  CHANGE_PLAN_USER,
  EDIT_APPLICATION,
  EDIT_SMARTCARD,
  GENERATE_MONTHLY_INVOICE,
  INVITE_DRIVER,
  LOGIN_AS_USER,
  MAKE_ACTIVE,
  MAKE_INACTIVE,
  NEW_RESERVATION_USER,
  QUIT_MEMBER,
  REJOIN_MEMBER,
  RESTRICT_MEMBER,
  UNASSIGN_SMARTCARD,
  UNRESTRICT_MEMBER,
  UPLOAD_FILE
} from '@/vuex/types'

export default {
  name: 'DemoAccountRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  components: {
    DropdownInput
  },
  computed: {
    ...mapGetters([
      'userActions',
      'loggedInUser'
    ]),
    membershipStatus () {
      let label = ''
      let text = ''
      if (this.account.memberQuit) {
        label = 'badge-warning'
        text = 'Quit'
      } else if (this.account.restricted) {
        label = 'badge-danger'
        text = 'Restricted'
      } else if (!this.account.activated) {
        label = 'badge-default'
        text = 'Inactive'
      } else {
        label = 'badge-success'
        text = 'Active'
      }
      return { label, text }
    },
    account () {
      return {
        AccountType: {},
        Reservations: [],
        CreditCards: [],
        ...this.object
      }
    }
  },
  data () {
    return {
      updatedAccount: {},
      url: 'https://techcar-dev.s3.amazonaws.com/'
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedAccount = result.updated
    },
    ...mapActions([
      ADD_ACCOUNT_NOTE,
      ADD_CREDITS,
      ADD_SMARTCARD,
      BLACKLIST_MEMBER,
      UN_BLACKLIST_MEMBER,
      CHANGE_PASS_USER,
      CHANGE_PLAN_USER,
      EDIT_APPLICATION,
      EDIT_SMARTCARD,
      GENERATE_MONTHLY_INVOICE,
      INVITE_DRIVER,
      LOGIN_AS_USER,
      MAKE_ACTIVE,
      MAKE_INACTIVE,
      NEW_RESERVATION_USER,
      QUIT_MEMBER,
      REJOIN_MEMBER,
      RESTRICT_MEMBER,
      UNASSIGN_SMARTCARD,
      UNRESTRICT_MEMBER,
      UPLOAD_FILE
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/DemoAccount.vue